module.exports = __webpack_public_path__ + "img/drugs.74b524b0.svg";